import React, { useEffect, useState } from 'react';
import { WorkExperiencePrimaryForm } from './components/WorkExperiencePrimaryForm';
import { ExperienceSummaryView } from './components/experienceSummary/ExperienceSummaryView';
import { AddMoreMonthsOfWorkExperience } from './components/AddMoreMonthsOfWorkExperience/AddMoreMonthsOfWorkExperience';
import { useWorkExperience } from './hooks/useWorkExperience';
import { LoadingState } from '../../components/LoadingState';
import { SetPageProps } from './interface';
import { useCurrentUserForWorkExperience, useWorkHistoryForWorkExperience } from './graphql';

export const WorkExperience = ({ isMobileVersion = false }: { isMobileVersion?: boolean }) => {
  const [page, setPage] = useState<SetPageProps>('loading');
  const { currentUser, currentUserLoading } = useCurrentUserForWorkExperience();
  const { workHistories, workHistoryLoading } = useWorkHistoryForWorkExperience();

  const workHistory = workHistories?.at(0);

  const loadingInitialData = currentUserLoading || workHistoryLoading;

  const hasOnlyOnePosition = currentUser?.professional?.professional_positions?.length === 1;

  const pages = {
    experienceSummary: <ExperienceSummaryView isMobileVersion={isMobileVersion} />,
    primaryForm: (
      <WorkExperiencePrimaryForm
        setPage={setPage}
        currentUser={currentUser || undefined}
        hasOnlyOnePosition={hasOnlyOnePosition}
      />
    ),
    addMoreMonths: (
      <AddMoreMonthsOfWorkExperience
        setPage={setPage}
        workHistories={workHistories}
        currentUser={currentUser || undefined}
        isLoading={loadingInitialData}
        isMobileVersion={isMobileVersion}
      />
    ),
    loading: <LoadingState />,
  };

  const { isMissingYoEFromMultiplesWorkHistories } = useWorkExperience({
    currentUser: currentUser || undefined,
    workHistories,
  });

  useEffect(() => {
    const getPage = () => {
      if (!workHistory) {
        return 'primaryForm';
      }
      if (
        isMissingYoEFromMultiplesWorkHistories({
          positionId: workHistory.position?.id,
        })
      ) {
        return 'addMoreMonths';
      }
      return 'experienceSummary';
    };
    if (!loadingInitialData) {
      setPage(getPage());
    }
  }, [currentUser, workHistories]);

  if (loadingInitialData) {
    return <LoadingState />;
  }

  return pages[page];
};
